// Global notification prompt utilities
let notificationPromptCallback = null;

export const setNotificationPromptCallback = (callback) => {
  notificationPromptCallback = callback;
};

export const showNotificationPrompt = (context = 'general') => {
  if (notificationPromptCallback) {
    notificationPromptCallback(context);
  }
};

export const showAfterBookingPrompt = () => {
  showNotificationPrompt('afterBooking');
};

export const showVideoLibraryPrompt = () => {
  showNotificationPrompt('videoLibrary');
};
